import createTransition from 'shared-tokens/utils/createTransition';
import colors from 'shared-tokens/utils/tokens/colors';

export const mainCls = 'checkbox-field';
export const clsInput = `${mainCls}__input`;
export const clsCtr = `${mainCls}__ctr`;
export const clsCtrIcon = `${mainCls}__ctr-icon`;
export const clsCtrIndet = `${mainCls}__ctr-inder`;

const boxSize = '18px';
const transitIndet = 'translateX(-50%) translateY(-50%)';
const colorBorder = colors.f3.rgba;
const colorBorderV2 = colors.border.rgba;
const colorTip = colors.w.rgba;
const colorTransp = 'rgba(255, 255, 255, 0)';

export default {
  [clsInput]: {
    position: 'absolute',
    width: 0,
    height: 0,
    padding: 0,
    border: 0,
    opacity: 0,

    [`&:checked + .${clsCtr}`]: {
      borderColor: colorTransp,

      [`& .${clsCtrIcon}`]: {
        opacity: '1',
        transform: 'scale(1)',
      }
    },

    [`&:disabled + .${clsCtr}`]: {
      opacity: '0.5',
    },

    [`&:indeterminate + .${clsCtr}`]: {

      [`& .${clsCtrIndet}`]: {
        opacity: '1',
        transform: transitIndet,
      }
    },
  },

  [mainCls]: {
    userSelect: 'none',
  },

  [clsCtr]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: boxSize,
    height: boxSize,
    borderRadius: '3px',
    border: `1px solid ${colorBorder}`,
    transition: createTransition(['background-color', 'border-color']),
    position: 'relative',
  },

  [clsCtrIcon]: {
    transform: 'scale(0)',
    transition: createTransition(['transform']),
    transformOrigin: 'center',
    '& path': {
      strokeWidth: 3,
    },
  },

  [clsCtrIndet]: {
    opacity: '0',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: `${transitIndet} scale(0)`,
    transition: createTransition(['transform']),
    width: 10,
    height: 2,
    backgroundColor: colorTip,
  },
  [`${mainCls}--v2`]: {
    [`& .${clsCtr}`]: {
      borderColor: colorBorderV2,
    },
    '&:hover': {
      color: colors.f0.rgba,
      transition: createTransition(['color']),
      [`& .${clsCtr}`]: {
        borderColor: colors.secondary.rgba,
      },
      [`& .${clsInput}`]: {
        [`&:checked + .${clsCtr}`]: {
          borderColor: colorTransp,
        },
      },
    },
  },
};

/**
 // Example animation checkmark
 @keyframes nd-checkbox-checkmark {
    0% {
        width: 0;
        height: 0
    }
​
    20% {
        width: .6rem;
        height: 0
    }
​
    40% {
        width: .6rem;
        height: 1rem
    }
​
    to {
        width: .6rem;
        height: 1rem
    }

 */